import styled from '@emotion/styled';
import { Button, Grid } from '@kc-console/common-ui';
import { IcChevronsLeftLargeRegular, IcChevronsRightLargeRegular } from '@kep/kcds-icons';

export interface LnbCollapseTriggerButtonProps {
  collapsed: boolean;
  onCollapse: () => void;
}

export default function LnbCollapseTriggerButton({
  collapsed,
  onCollapse,
}: LnbCollapseTriggerButtonProps) {
  return (
    <StyledLnbCollapseTriggerButton
      type="button"
      variant="secondary"
      size="lg"
      onClick={onCollapse}
    >
      <LnbCollapseIconContainer container justifyContent={'center'} alignItems={'center'}>
        {collapsed ? <IcChevronsRightLargeRegular /> : <IcChevronsLeftLargeRegular />}
      </LnbCollapseIconContainer>
    </StyledLnbCollapseTriggerButton>
  );
}

const StyledLnbCollapseTriggerButton = styled(Button)`
  display: flex;
  padding: 0 16px;
  justify-content: end;
  align-items: center;
  height: 40px;
  min-width: unset;
  border: none;
  border-radius: 0;
  box-shadow: none;
  text-transform: none;
  background-color: ${({ theme }) => theme.color['surface/neutral/default']};
  color: inherit;
  cursor: pointer;

  .Button-label {
    padding: 0;
  }

  &:hover {
    box-shadow: none;
    background-color: ${({ theme }) => theme.color['surface/neutral/hover']};
  }

  &:active {
    box-shadow: none;
    background-color: ${({ theme }) => theme.color['surface/neutral/press']};
  }

  &:focus-visible {
    position: relative;
    ${({ theme }) => theme.mixins.focusRing('inside')};
  }
`;

const LnbCollapseIconContainer = styled(Grid)`
  width: 24px;
  height: 24px;
`;
